import React from "react"

const ServiceCard = ({ images, title, content }) => {
  return (
    <div className="rounded-t-[1.25rem] bg-white drop-shadow-xl  ">
      <div className="w-fit overflow-hidden">
        <img src={images} alt="" className="" />
      </div>
      <div className="text-[#2C2C2C] px-[2.5rem] py-[1.5rem] w-[22.1rem] ">
        <h1 className="font-medium ">{title}</h1>
        <p className="text-[0.75rem] leading-[137%] ">{content}</p>
      </div>
    </div>
  )
}

export default ServiceCard
